import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { analyzeImage, gradeDefects, uploadImage } from "../utils/API";
import { compressImage } from "../utils/image";
import { DefectJson, GradeHistoryItem } from "../types/grading";
import {
  addToHistory,
  getOrCreateUserId,
  writeLastResult,
} from "../utils/storage";

type LocationState = { file?: File };

const steps = [
  "Compressing image",
  "Uploading",
  "Detecting defects",
  "Grading and pricing",
  "Saving history",
] as const;

export default function LoadingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state || {}) as LocationState;
  const file = state.file;

  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const safeFileName = useMemo(() => file?.name || "image", [file?.name]);

  // useEffect(() => {
  //   let cancelled = false;

  //   async function run() {
  //     if (!file) {
  //       setError("No image found. Please upload again.");
  //       return;
  //     }

  //     try {
  //       setError(null);

  //       setActiveStep(0);
  //       const compressed = await compressImage(file);
  //       if (cancelled) return;

  //       setActiveStep(1);
  //       const upload = await uploadImage(compressed);
  //       if (cancelled) return;

  //       setActiveStep(2);
  //       const defects: DefectJson = await analyzeImage(upload.image_url);
  //       if (cancelled) return;

  //       setActiveStep(3);
  //       const grade = await gradeDefects(defects);
  //       if (cancelled) return;

  //       setActiveStep(4);
  //       const userId = getOrCreateUserId();
  //       const item: GradeHistoryItem = {
  //         id:
  //           typeof crypto !== "undefined" && "randomUUID" in crypto
  //             ? crypto.randomUUID()
  //             : `grade_${Date.now()}_${Math.random().toString(16).slice(2)}`,
  //         user_id: userId,
  //         image_url: upload.image_url,
  //         defects_json: defects,
  //         ai_grade: grade.grade,
  //         ai_reason: grade.reason,
  //         market_price: grade.market_price,
  //         recommendation: grade.recommendation,
  //         created_at: new Date().toISOString(),
  //       };

  //       addToHistory(item);
  //       writeLastResult(item);

  //       navigate("/result", { replace: true, state: { item } });
  //     } catch (e: any) {
  //       setError(e?.message || "Something went wrong.");
  //     }
  //   }

  //   run();
  //   return () => {
  //     cancelled = true;
  //   };
  // }, [file, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-6">
      <div className="w-full max-w-xl">
        <div className="rounded-2xl border border-slate-800 bg-slate-900 p-8">
          <div className="text-lg font-semibold">Analyzing your card…</div>
          <div className="mt-2 text-sm text-slate-300">
            {file ? safeFileName : "No file"} • Please keep this tab open
          </div>

          {error ? (
            <div className="mt-6 rounded-lg border border-rose-800 bg-rose-950/40 p-4 text-rose-100">
              <div className="font-medium">Error</div>
              <div className="mt-1 text-sm text-rose-200">{error}</div>
              <div className="mt-4 flex gap-3">
                <Link
                  to="/upload"
                  className="rounded-md bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-400"
                >
                  Back to upload
                </Link>
              </div>
            </div>
          ) : (
            <>
              <div className="mt-6 h-2 w-full overflow-hidden rounded-full bg-slate-800">
                <div
                  className="h-2 rounded-full bg-indigo-500 transition-all"
                  style={{
                    width: `${Math.round(((activeStep + 1) / steps.length) * 100)}%`,
                  }}
                />
              </div>

              <ul className="mt-6 space-y-2 text-sm">
                {steps.map((s, idx) => {
                  const isActive = idx === activeStep;
                  const isDone = idx < activeStep;
                  return (
                    <li
                      key={s}
                      className={[
                        "flex items-center justify-between rounded-md px-3 py-2",
                        isActive
                          ? "bg-indigo-500/10 text-indigo-100"
                          : "text-slate-300",
                      ].join(" ")}
                    >
                      <span>
                        {isDone ? "✓ " : isActive ? "• " : "○ "}
                        {s}
                      </span>
                      <span className="text-xs text-slate-400">
                        {isDone ? "Done" : isActive ? "Running" : "Queued"}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
